 /*-----------------------------------------------------------------------------------
    Main
    Author: Rodrigo Bouza
    ---------------------------------- */

 ;
 (function (w) {
     'use strict';

     function Main() {
         var inTransition = false;

         var participantes = new Participantes();
         
         // Tack eventos del sponsor
         $('a[data-track]').on('click', function(evt){
           evt.preventDefault();
           
           var category = $(this).attr('data-track');
           var url = $(this).attr('href');
           
           gtag('event', 'click', {
             'event_category': category,
             'event_label': url,
             'transport_type': 'beacon',
             'event_callback': function(){
               window.open(url, '_blank');
             }
          });
          
          return false;
         });

         // Btn menu
         $('#btn_menu').click(function (e) {
             e.preventDefault();

             $('body').toggleClass('menu-open');
         });

         // Menu items
         $('#main_menu > ul > li > a').click(function (e) {
             e.preventDefault();

             var $this = $(this);
             var scrollTop = $(document).scrollTop();
             var anchorEl = $($this.attr('href'));
             var animDistance = anchorEl.offset().top < scrollTop ? $(window).height() : -$(window).height();
             var offsetAnchorEl = $this.attr('href').indexOf("tab_soluciones") === -1 &&
                 $this.attr('href').indexOf("home") === -1 ? 30 : -1;

             //$('#main_menu > ul > li > a.active').removeClass('active');
             //$this.addClass('active');

             setTimeout(function () {
                 $(window).scrollTop(anchorEl.offset().top + animDistance);
                 $('body').removeClass('menu-open');

                 setTimeout(function () {
                     scrollToElement(anchorEl, 500, offsetAnchorEl);
                 }, 350);
             }, 50);
         });

         $('#facebook_share_btn, #facebook_share_btn_footer').bind('click', function (e) {
             e.preventDefault();

             window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(Main.baseUrl), 'fbShareWindow', 'height=600, width=550, top=' + (document.documentElement.clientHeight / 2 - 275) + ', left=' + (document.documentElement.clientWidth / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
         })

         $('#twitter_share_btn, #twitter_share_btn_footer').bind('click', function (e) {
             e.preventDefault();

             var tweet = "16 soluciones a plásticos de un solo uso que podés implementar en tu vida";

             window.open('https://twitter.com/intent/tweet?text=' + encodeURIComponent(tweet) + '&url=' + encodeURIComponent(Main.baseUrl), 'fbShareWindow', 'height=450, width=550, top=' + (document.documentElement.clientHeight / 2 - 275) + ', left=' + (document.documentElement.clientWidth / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
         })

         $('#whatsapp_share_btn, #whatsapp_share_btn_footer').bind('click', function (e) {
             e.preventDefault();

             var msg = "16 soluciones a plásticos de un solo uso que podés implementar en tu vida";
             window.location = 'https://api.whatsapp.com/send?text=' + encodeURIComponent(msg + ' ' + Main.baseUrl);
             //window.location = 'whatsapp://send?text='+encodeURIComponent(msg + ' ' +  Main.baseUrl);//https://wa.me/?text=
         })

         // Parallax effects
         if ($(window).width() > 992 && !Utils.isMobile()) {
             $('.bg-circle').each(function () {
                 var maxParallax = 0.15;
                 var factorMax = $(this).data('scroll-direction') === 'up' ? maxParallax : -maxParallax;
                 var factorRand = Math.random() * factorMax;
                 //console.log(factorRand);

                 $(this).paroller({
                     factor: factorRand,
                     type: 'foreground',
                     direction: 'vertical',
                     transition: 'all 0s linear'
                 });
             });

             $('#counter_year').paroller({
                 factor: 0.3,
                 type: 'foreground',
                 direction: 'vertical',
                 transition: 'all 0s linear'
             });
         }

         // Scroll init
         setTimeout(function () {
             $('html').scrollTop(0);
         }, 50);


         // WOW
         var wow = new WOW({
             boxClass: 'wow',
             offset: 50,
             mobile: true,
             live: true
         });
         wow.init();

         // Slider Cards Gray Context
         var slider_context = tns({
             container: '#slider_context_countries',
             items: 1,
             slideBy: 'page',
             nav: false,
             controls: false,
             autoWidth: false,
             gutter: 0,
             edgePadding: 30,
             mouseDrag: true,
             loop: false,
             autoHeight: false,
             responsive: {
                 640: {
                     edgePadding: 0,
                 },
                 992: {
                     autoHeight: true,
                 }
             }
         });

         slider_context.events.on('indexChanged', function (slider) {
             $('#nav_dots_slider_context_countries a').removeClass('active');
             $('#nav_dots_slider_context_countries li:nth-of-type(' + (slider.index + 1) + ') a').addClass('active');
         });

         // Slider Cards dots
         $('#nav_dots_slider_context_countries a').click(function (e) {
             e.preventDefault();

             var index = $(this).parent().index();
             slider_context.goTo(index);
         });

         // Slider Cards Gray Enterprise Solutions
         var slider_enterprise_solutions = tns({
             container: '#slider_enterprise_solutions',
             items: 1,
             slideBy: 'page',
             nav: false,
             controls: false,
             autoWidth: false,
             gutter: 0,
             edgePadding: 30,
             mouseDrag: true,
             loop: false,
             autoHeight: false,
             responsive: {
                 640: {
                     edgePadding: 0,
                 },
                 992: {
                     autoHeight: true,
                 }
             }
         });

         slider_enterprise_solutions.events.on('indexChanged', function (slider) {
             $('#nav_dots_slider_enterprise_solutions a').removeClass('active');
             $('#nav_dots_slider_enterprise_solutions li:nth-of-type(' + (slider.index + 1) + ') a').addClass('active');
         });

         // Slider Cards dots
         $('#nav_dots_slider_enterprise_solutions a').click(function (e) {
             e.preventDefault();

             var index = $(this).parent().index();
             slider_enterprise_solutions.goTo(index);
         });

         // Slider Thumbs nav
         var slider_thumbs_nav = tns({
             container: '#nav_photos_slider_thumbs',
             items: 3,
             slideBy: 'page',
             nav: false,
             controls: false,
             autoWidth: false,
             edgePadding: 60,
             gutter: 0,
             mouseDrag: true,
             loop: false,
             responsive: {
                 320: {
                     edgePadding: 35,
                 },
                 490: {
                     disable: true,
                 },
             }
         });

         // Collapsable items
         $('.collapsable-item').click(function () {
             $(this).toggleClass('active');
             var content = $(this).next();
             content.slideToggle(function () {
                 content.toggleClass('active');
             });
         });

         // Scroll To Element
         $('.scrollToElement').click(function (e) {
             e.preventDefault();

             if (!Utils.isMobile() && $(this).closest('#nav_btns_soluciones').length > 0) {
                 scrollToElement($($(this).data('scroll')), 750, 100);
             } else {
                 scrollToElement($($(this).data('scroll')), 750, 0);
             }
         });

         // Scroll To Element
         function scrollToElement(el, speed, offset) {
             offset = typeof offset !== 'undefined' ? offset : 0;

             $([document.documentElement, document.body]).animate({
                 scrollTop: el.offset().top - offset
             }, speed, 'easeInOutCirc');
         }

         $('#nav_btns_soluciones a').click(function (e) {
             e.preventDefault();

             goTabSoluciones($(this).parent().index());
         })

         // Nav tab fixed Soluciones
         $('#nav_btn_soluciones_top_fixed a').click(function (e) {
             e.preventDefault();

             goTabSoluciones($(this).parent().index());
         });

         function goTabSoluciones(index) {
             var tabContent = $('.tab-content-primary.tab-content').eq(index);

             if (!Utils.isMobile() && $(window).width() > 992) { //Desktop
                 $('.tab-content-primary.tab-content.active').fadeOut(function () {
                     $('.tab-content-primary.tab-content.active').removeClass('active');

                     $('#nav_btn_soluciones_top_fixed li a.active').removeClass('active');
                     $('#nav_btn_soluciones_top_fixed li').eq(index).find('a').addClass('active');

                     tabContent.fadeIn(function () {
                         tabContent.addClass('active');
                         scrollToElement(tabContent, 750, 100);
                         slider_context.refresh();
                         slider_enterprise_solutions.refresh();
                     })
                 })

             } else { //Mobile
                 $('.tab-content-primary.tab-content.active').removeClass('active');
                 $('#nav_btn_soluciones_top_fixed li a.active').removeClass('active');
                 $('#nav_btn_soluciones_top_fixed li').eq(index).find('a').addClass('active');

                 tabContent.addClass('active');
                 slider_context.refresh();
                 slider_enterprise_solutions.refresh();

                 scrollToElement(tabContent, 750, 0);
             }

         }

         // Nav Mobile otras soluciones
         $('.nav_other_solutions a').click(function (e) {
             e.preventDefault();

             var tab = $($(this).attr('href'));
             var activeTabPrimary = $(this).closest('.tab-content-primary');
             var activeTab = activeTabPrimary.find('.tab-content.active');
             var $this = $(this);

             if (!Utils.isMobile() && $(window).width() > 992) {
                 scrollToElement(activeTabPrimary, 750, 100);
             } else {
                 scrollToElement(activeTabPrimary, 750, 0);
             }

             setTimeout(function () {
                 activeTab.fadeOut(function () {
                     activeTab.removeClass('active');

                     tab.fadeIn(function () {
                         tab.addClass('active');
                         $(document).scrollTop($(document).scrollTop() + 1);

                         $('.nav_other_solutions li.active').removeClass('active');
                         $this.parent().addClass('active');
                     });
                 });
             }, 700);
         });

         // On scroll
         $(window).scroll(function (e) {
             var scrollTop = $(document).scrollTop();

             // Btns Soluciones
             var nav_btns_soluciones = $('#nav_btns_soluciones'),
                 nav_btn_soluciones_top_fixed = $('#nav_btn_soluciones_top_fixed');

             // Nav  Soluciones Desktop
             if (scrollTop >= (nav_btns_soluciones.offset().top + nav_btns_soluciones.height()) &&
                 scrollTop < ($('#section_contexto').offset().top - $('#section_contexto').height() / 4) &&
                 !nav_btn_soluciones_top_fixed.hasClass('active') &&
                 !inTransition) {
                 nav_btn_soluciones_top_fixed.addClass('active');
                 setTimeout(function () {
                     nav_btn_soluciones_top_fixed.addClass('in');
                 }, 50);
             } else if ((
                     scrollTop < (nav_btns_soluciones.offset().top + nav_btns_soluciones.height()) ||
                     scrollTop >= ($('#section_contexto').offset().top - $('#section_contexto').height() / 4)
                 ) &&
                 nav_btn_soluciones_top_fixed.hasClass('active') &&
                 !inTransition) {
                 inTransition = true;
                 nav_btn_soluciones_top_fixed.removeClass('in');
                 setTimeout(function () {
                     nav_btn_soluciones_top_fixed.removeClass('active');
                     inTransition = false;
                 }, 750);
             }

             // Nav Content arrows
             if (scrollTop >= $('#section_soluciones').offset().top && !$('#nav_content_arrows').hasClass('active')) {
                 $('#nav_content_arrows').addClass('active');
                 setTimeout(function () {
                     $('#nav_content_arrows').addClass('in');
                 }, 0);
             } else if (scrollTop < $('#section_soluciones').offset().top && $('#nav_content_arrows').hasClass('active')) {
                 $('#nav_content_arrows').removeClass('in');
                 setTimeout(function () {
                     $('#nav_content_arrows').removeClass('active');
                 }, 750);
             }

             // Btn menu show
             if (scrollTop >= ($('#section_home').height() / 2) && !$('body').hasClass('btn-menu-show')) {
                 $('body').addClass('btn-menu-show');
             } else if (scrollTop < ($('#section_home').height() / 2) && $('body').hasClass('btn-menu-show')) {
                 $('body').removeClass('btn-menu-show');
             }

             // Menu active link change
             if (Utils.isMobile() || $(window).width() < 992) {
                 $('#main_menu li a').each(function (e) {
                     var currLink = $(this);
                     var refElement = $(currLink.attr("href"));
                     var offsetAnchorEl = currLink.attr('href').indexOf("tab_soluciones") === -1 &&
                                          currLink.attr('href').indexOf("home") === -1 ? 30 : -1;

                     if ( (scrollTop + offsetAnchorEl + 1) >= (refElement.offset().top)
                         && (scrollTop - offsetAnchorEl) < refElement.offset().top + refElement.height()) {
                         $('#main_menu li a').removeClass("active");
                         currLink.addClass("active");
                     } else {
                         currLink.removeClass("active");
                     }
                 });
             }
         });
     }

     w.Main = Main;
 })(window)
